export const claimRol = {};
export const loading = {};

export const altMenuList = null;
export const menuShow = false;

export const timerIdEnvanterIgneDataTransfer= null;
export const personelResimler =   null;
export const filtreMusteriler =   null;
